import './public-path' //do not remove this public-path import - used for cdn url in app
import 'es6-promise/auto';
import Logger from "@/utils/logger"
import logger from "@/utils/global-logger"
import CurrencyFilter from "@/filters/currency"
import dompolyfills from "@/utils/dom-polyfills.js"
import vendorpolyfills from "@/utils/vendor-polyfills.js"
import formHelpers from "@/directives/form.js"
import reportError from "@/directives/report-error.js"
import CBStyleConfig from '@/directives/styles.js'
// import ToggleButton from 'vue-js-toggle-button'
import CbSlide from "@/transitions/cb-slide"
import CbAnimate from "@/transitions/cb-animate"
import SlideNFadeTransition from "@/transitions/SlideNFadeTransition"
import ToggleAnimation from "@/transitions/ToggleAnimation"
import cbStorage from "@/utils/cb-storage"
import CbLink from "@/directives/cb-link"
import Vhtml from "@/directives/vhtml"
import ImportHelper from '@/utils/chunkImportWrapper'
import { CDN } from '@/components/modules/hosted-pages/LazyLoadPaymentComponents'
import RecaptchaUtil from '@/utils/recaptcha';
import { PaymentErrorCode } from '@/utils/error-codes/payment';
import { UiErrorCode } from '@/utils/error-codes/ui';
import { GOOGLE_MAPS_LOAD_ERROR_MESSAGE } from '@/utils/error-messages';
import { installVueRuntimeErrorHandlers } from '@/utils/vue-runtime-error-handlers';

window.addEventListener("beforeunload", function(e) {
  // Disabling frame unload event, until preview portal is fixed in UI
  // window.cbPostMessage("cb.frameunload")
})
// Vue.use(ToggleButton)com

export const configureApp = (app) => {
  app.config.compatConfig = { MODE: 2 };
  app.config.compilerOptions = app.config.compilerOptions || {};
  app.config.compilerOptions.compatConfig = { MODE: 2 };
  installVueRuntimeErrorHandlers(app);
  // Currency formatting (`cbCurrency`). Templates must call it as a function:
  // `{{ cbCurrency(amount, currency_code, ...) }}`. Vue 3 does not compile
  // Vue 2 pipe-filter syntax (`|`), so `{{ amount | cbCurrency(code) }}` turns
  // into JS bitwise OR and renders wrong totals (e.g. raw cents).
  //
  // Also keep this on globalProperties so `_ctx.cbCurrency(...)` resolves in SFC
  // templates whether or not @vue/compat filter compilation is enabled.
  //
  // 2. Script usage like `this.$options.filters.cbCurrency(...)` which is
  //    used in a number of components. We register the filter via
  //    `app.filter()` (the @vue/compat shim) AND via a global `beforeCreate`
  //    mixin that populates `$options.filters.cbCurrency` on every instance,
  //    so the existing Vue 2 access pattern keeps working unchanged.
  app.config.globalProperties.cbCurrency = CurrencyFilter;
  app.config.globalProperties.$filters = app.config.globalProperties.$filters || {};
  app.config.globalProperties.$filters.cbCurrency = CurrencyFilter;
  // app.filter exists only under @vue/compat (MODE 2). After MODE 3 it is removed;
  // cbCurrency still works via globalProperties and the beforeCreate mixin below.
  if (typeof app.filter === 'function') {
    app.filter('cbCurrency', CurrencyFilter);
  }
  app.mixin({
    beforeCreate() {
      const opts = this.$options;
      if (!opts.filters) opts.filters = {};
      if (!opts.filters.cbCurrency) opts.filters.cbCurrency = CurrencyFilter;
    }
  });
  app.use(formHelpers);
  app.use(reportError);
  app.use(CBStyleConfig);
  app.directive('cb-slide', CbSlide);
  app.component('cb-slide-n-fade', SlideNFadeTransition);
  app.component('cb-toggle', ToggleAnimation);
  app.directive('cb-animate', CbAnimate);
  app.directive('cb-link', CbLink);
  app.directive('cb-html', Vhtml);
}


const isMobileOrTablet = function() {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
}
const isMobileResolution = ()=>{
  return window.innerWidth <= 480 || window.innerHeight <= 480;
}

window.isMobile = isMobileOrTablet();

window.isMobileResolution = isMobileResolution();

window.cbTimeout = (func, timer) => {
  return window.setTimeout(() => {
    try {
      func();
    }
    catch(error) {
      logger.error(UiErrorCode.HELPER_FAILED, { failurePoint: 'cbTimeout', delayMs: timer, moduleId: 'common' }, error);
    }
  }, timer);
}

/**
 * Move focus to the visible app shell. Prefer inner `.cb-hp` over the mount host
 * (`#portal` is full-width; focusing it draws the browser’s default focus ring as
 * long blue lines at top/bottom). `.cb-hp` already has `outline: none` in app.styl.
 * Paynow uses `.cb-page` only — fall back to the mount node.
 */
window.cbFocusAppRoot = () => {
  const host = document.getElementById('portal')
    || document.getElementById('paynow')
    || document.getElementById('claim_gift')
    || document.getElementById('connector')
    || document.getElementById('view_voucher')
    || document.getElementById('app');
  if (!host) return;
  let el = host.classList?.contains('cb-hp') ? host : host.querySelector('.cb-hp');
  if (!el) el = host;
  if (typeof el.focus !== 'function') return;
  if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
  try {
    el.focus();
  } catch (e) {}
};

window.cbPostMessage = function(event, referrerDomain) {
  let domain = referrerDomain ? referrerDomain : "*";
  if(window.parent != window){
    window.parent.postMessage(event, domain);
  }
  else {
    if(window.opener) {
      window.opener.postMessage(event, domain);
    }
  }
}

window.cbReload = function() {
  if(window.isOpenedByCb || window.cbReferrer) {
    let queryToAppend = "";
    if(window.isOpenedByCb) {
      queryToAppend += "hp_opener=chargebee";
    }
    if(window.cbReferrer) {
      queryToAppend += `${queryToAppend ? '&': ''}hp_referrer=${window.cbReferrer}`;
    }
    if(document.location.search.startsWith("?")) {
      document.location.search += queryToAppend;
    }
    else {
      document.location.search += `&${queryToAppend}`;
    }
  }
  else {
    window.location.reload();
  }
}

window.logger = new Logger(Logger.DEBUG, true, window.initInfo && window.initInfo.sentry);
window.cbStorage = cbStorage;

function loadDependencies() {
  if(!window.mapsLoaded) {
    window.mapsLoaded = function() {
      window.googleMapsLoaded = true
    }
  }
  if(window.initInfo && window.initInfo.google_maps_apikey) {
    let key = window.initInfo.google_maps_apikey
    ImportHelper.loadScript(`https://maps.googleapis.com/maps/api/js?key=${key}&libraries=places&callback=mapsLoaded`, null, () => !!(window.google && window.google.maps))
      .catch(e => logger.error(UiErrorCode.SCRIPT_LOAD_FAILED, { scriptContext: 'google_maps' }, e || new Error(GOOGLE_MAPS_LOAD_ERROR_MESSAGE)))
  }

  // Load Chargebee.js by default
  window.cbjsLoader = ImportHelper.loadScript(CDN.chargebeejs, null, 'Chargebee').then(() => {
    const cbjsInitOptions = {
      site: window.initInfo.site,
      domain: window.location.origin,
      locale: window.initInfo.init_info_locale,
      cspNonce: window._hp_csp_nonce
    };
    Chargebee.init(cbjsInitOptions);
  }).then(() => {
    const cbInstance = Chargebee.getInstance();
    if (cbInstance && RecaptchaUtil.isRecaptchaEnabled()) {
      cbInstance.initializeCaptcha({
        siteKey: window.initInfo.captcha_site_key || window.initInfo.recaptcha_site_key,
        provider: window.initInfo.captcha_provider,
        isGlobalRecaptcha: RecaptchaUtil.isRecaptchaGloballySupported(),
      });
    }
  }).catch(error => {
    logger.error(PaymentErrorCode.CHARGEBEE_JS_LOAD_FAILED, { scriptUrl: CDN.chargebeejs }, error);
    throw error; // Keep promise rejected so entrypoints don't run .then() and call getInstance() on failed load
  });
}

loadDependencies()

window.debounce = function debounce(func, wait, immediate) {
  let timeout;
	return function() {
		const thisArg = this;
		const args = arguments;
		const later = function() {
			timeout = null;
			if (!immediate) {
        func.apply(thisArg, args);
      }
		};
		const callNow = immediate && !timeout;
    clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) {
      func.apply(thisArg, args);
    }
	};
};
